<template>
  <div class="cloud-college">
    <headBox title="营销中心" class="head-box">
      <div class="search-box" v-show="!productId">
        <el-input placeholder="请输入关键字搜索" @keyup.native.enter="getTypeList()" v-model="searchText"></el-input>
        <el-button class="cxbtn" type="warning" @click="getTypeList()">查询</el-button>
      </div>
    </headBox>
    <div class="search-result" v-if="productId || searchTextValue">
      <div class="top-title">
        搜索“<span class="prod-color">{{ productName || searchTextValue }}</span
        >”，共搜索<span class="num-color">{{ totalCount }}</span
        >条结果
        <img src="@static/images/product/close.png" class="icon-close" @click="clearSearch" />
      </div>
      <div class="btn" v-if="productId">
        <el-button class="org-btn" plain @click="jumpProductUrl(productId)">查看产品详情</el-button>
      </div>
    </div>

    <div class="college" v-loading="loading">
      <div class="top-box" v-if="navTab.length">
        <div class="header-tab">
          <div v-for="(item, index) in navTab" :key="index" :class="index == index1 ? 'active' : ''" @click="topTabClick(item, index)">
            {{ getTypeText(item) }}
          </div>
        </div>
      </div>
      <div class="nav-second-tab" v-if="navTab2.length">
        <div class="tab-body">
          <span
            v-for="(theme, i) in navTab2"
            :class="i == index2 ? 'active' : ''"
            :key="i"
            @click="
              index2 = i;
              navClick(theme, 3);
            "
            >{{ theme.name }}</span
          >
        </div>
      </div>

      <div class="card-content">
        <!-- 产品资料包 -->
        <product-download :list="tableData" v-if="curChildData.type == 1"></product-download>
        <!-- 海报 -->
        <poster-center :list="tableData" v-if="curChildData.type == 2" @jumpProductUrl="jumpProductUrl"></poster-center>
        <!-- 文章素材 -->
        <article-list :list="tableData" :type="curChildData.type" v-if="curChildData.type == 3 || curChildData.type == 4"></article-list>
        <!-- 卡片式 -->
        <training-center :list="tableData" v-if="curChildData.type == 5"></training-center>
        <!-- 视频 -->
        <product-video :list="tableData" v-if="curChildData.type == 6"></product-video>

        <empty-box v-if="!loading && !tableData.length"></empty-box>
      </div>
      <el-pagination
        v-if="tableData.length"
        background
        layout="total,prev,pager,next,jumper"
        @size-change="
          pageNum = 1;
          pageSize = $event;
          getList();
        "
        :page-size="pageSize"
        :current-page.sync="pageNum"
        @current-change="handlePageChange"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 团财险选择档次 -->
    <select-grade-modal ref="selectGradeModal"></select-grade-modal>
  </div>
</template>

<script>
import headBox from '@/components/head.vue';
import ProductVideo from './components/productVideo';
import TrainingCenter from './components/trainingCenter';
import ServiceGuide from './components/serviceGuide';
import PosterCenter from './components/posterCenter';
import ProductDownload from './components/productDownload';
import ArticleList from './components/articleList';
import selectGradeModal from './productlibrary/components/selectGradeModal';
export default {
  data: () => ({
    navTab: [],
    navTab2: [], //二级分类
    navTab3: [], //3级分类
    navTab4: [], //4级分类
    index1: 0,
    index2: 0,
    index3: 0,
    index4: 0,
    curChildData: {}, //当前选中的子分类
    pageNum: 1,
    pageSize: 10,
    total: 0,
    tableData: [], //列表数据
    loading: false,
    productId: '', // 是否是从产品页面进入
    productName: '',
    searchText: '',
    searchTextValue: '', //当前查询的关键字
    totalCount: 0, //查询记录总数
    showAllList: false, //是否显示所有分类
    clientWidth: document.body.clientWidth,
    activeNum: 0,
    themeActive: 3
  }),
  watch: {
    '$route.query.productId': {
      handler(data) {
        if (this.$route.query.productId) {
          this.productId = this.$route.query.productId;
          this.productName = this.$route.query.productName;
        } else {
          this.productId = '';
          this.productName = '';
        }
        this.getTypeList();
      }
    }
  },
  computed: {},
  mounted() {},
  created() {
    this.productId = this.$route.query.productId;
    this.productName = this.$route.query.productName;
    this.getTypeList();
  },
  methods: {
    // 翻页后滚动到页面顶部
    handlePageChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
      window.scrollTo(0, 0);
    },
    // 清除查询
    clearSearch() {
      this.index1 = 0;
      if (this.productId) {
        this.loading = true;
        this.$router.replace('/cloudCollege');
      } else {
        this.searchText = '';
        this.getTypeList();
      }
    },
    topTabClick(item, index) {
      if (item.code == 'trainingCenter') {
        // 培训中心特殊处理
        this.$http({
          url: '/master/information/trainSysLogin',
          type: 'get',
          params: {}
        }).then(res => {
          window.open(res.data);
        });
        return;
      }
      this.index1 = index;
      this.navClick(item, 2);
    },
    // 跳转产品地址
    jumpProductUrl(productId) {
      if (!productId) return;
      this.$http({
        url: '/master/product/queryUrl',
        type: 'get',
        params: {
          productId: productId
        }
      }).then(res => {
        const item = res.data;
        if (item.productCategory == 1 || item.productCategory == 2) {
          //团财险
          this.$refs.selectGradeModal.open(
            {
              ...item,
              product: {
                productNo: item.productCode
              }
            },
            'jump'
          );
          return;
        }
        let insureType = item.insureType;
        let url = item.url;
        // ZYRS=中意，中意经代产品固定进入业务员链接
        if (insureType.includes('6')) {
          url = item.url.replace('/product/', '/product/app/');
        }
        window.open(url, '_blank');
      });
    },
    // 获取分类文本
    getTypeText(item) {
      if (this.productId || this.searchTextValue) {
        return item.name + '(' + item.count + ')';
      } else {
        return item.name;
      }
    },
    // 获取主分类数据
    getTypeList() {
      const params = {};
      let url = '/master/information/queryLevelTree';
      if (this.productId) {
        params.productId = this.productId;
        this.index1 = 0;
      }
      if (this.searchText) {
        params.keyWord = this.searchText;
        this.index1 = 0;
      }
      if (this.productId || this.searchText) {
        url = '/master/information/queryLevelTreeSearch';
      }
      this.loading = true;
      this.$http({
        url: url,
        type: 'put',
        params: params
      }).then(res => {
        if (res.data && res.data.length) {
          this.navTab = res.data;
          this.totalCount = res.totalCount;
          this.setChildTypeList(this.navTab[this.index1].child, 2);
        } else {
          this.loading = false;
          this.searchTextValue = this.searchText;
          this.totalCount = 0;
          this.navTab = [];
          this.navTab2 = [];
          this.navTab3 = [];
          this.navTab4 = [];
          this.tableData = [];
        }
      });
    },
    // 分类点击
    navClick(nav, level) {
      this.tableData = [];
      this.setChildTypeList(nav.child, level);
      if (!nav.child || !nav.child.length) {
        this.curChildData = nav;
        this.pageNum = 1;
        this.getList();
      }
    },
    // 获取产品分类
    getProductType(nav, level) {
      this.$http({
        url: '/master/information/poster/hotProduct',
        type: 'put',
        params: {
          typeId: nav.id,
          keyWord: this.searchText
        }
      })
        .then(res => {
          if (!res.data || !res.data.length) {
            return;
          }
          let key = '';
          if (level == 2) {
            key = 'navTab2';
            this.index2 = 0;
          } else if (level == 3) {
            key = 'navTab3';
            this.index3 = 0;
          } else if (level == 4) {
            key = 'navTab4';
            this.index4 = 0;
          } else {
            return;
          }
          this[key] = res.data.map(item => {
            return {
              name: item.productName,
              productId: item.productId,
              code: nav.code,
              type: nav.type
            };
          });
          this.curChildData = this[key][0];
          this.pageNum = 1;
          this.getList();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 设置子分类
    setChildTypeList(data, level) {
      let key = '';
      if (level == 2) {
        key = 'navTab2';
        this.index2 = 0;
      } else if (level == 3) {
        key = 'navTab3';
        this.index3 = 0;
      } else if (level == 4) {
        key = 'navTab4';
        this.index4 = 0;
      } else {
        return;
      }
      if (data && data.length) {
        this[key] = data;
        if (data[0].child && data[0].child.length) {
          this.setChildTypeList(data[0].child, ++level);
        } else {
          this.setChildTypeList([], ++level);
          this.curChildData = data[0];
          this.pageNum = 1;
          this.getList();
        }
      } else {
        this[key] = [];
        this.setChildTypeList([], ++level);
      }
    },
    // 获取查询参数
    getParams() {
      const params = {
        typeId: this.curChildData.id,
        code: this.curChildData.code,
        themeId: this.curChildData.themeId
        // informationType: this.curChildData.type,
      };
      // if([3,4,5,6].includes(this.curChildData.type*1)){
      //   params.informationType = this.curChildData.type;
      // }
      if (this.productId) {
        // params.informationType = this.curChildData.type;
        params.productId = this.productId;
      }
      if (this.curChildData.productId) {
        params.productId = this.curChildData.productId;
      }
      if (this.searchText) {
        this.searchTextValue = this.searchText;
        params.keyWord = this.searchText;
      } else {
        this.searchTextValue = '';
      }
      return params;
    },
    // 获取列表数据
    getList() {
      const type = this.curChildData.type;
      const params = this.getParams();
      params.pageNum = this.pageNum;
      this.pageSize = 10;
      let url = '';
      if (type == 1) {
        url = '/master/information/queryFileList';
      } else if (type == 2) {
        url = '/master/information/queryPosterList';
        this.pageSize = 12;
      } else if (type == 3 || type == 4 || type == 5 || type == 6) {
        url = '/master/information/queryArticleList';
      }
      if (type == 6 || type == 5) {
        this.pageSize = 12;
      }
      params.pageSize = this.pageSize;
      this.loading = true;
      this.$http({
        url: url,
        type: 'put',
        params: params
      })
        .then(data => {
          data.data.forEach(item => {
            item.checked = false;
            if (item.label) {
              item.label = item.label.split(',');
            } else {
              item.label = [];
            }
          });
          this.tableData = data.data;
          this.total = data.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //查询
    search() {
      this.pageNum = 1;
      this.getList();
    }
  },
  components: {
    selectGradeModal,
    headBox,
    ProductVideo,
    TrainingCenter,
    ServiceGuide,
    PosterCenter,
    ProductDownload,
    ArticleList
  }
};
</script>

<style lang="scss" scoped>
@import './cloudCollege';
</style>
